import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { supabase } from '../lib/supabaseClient';
import { dogs as staticDogs } from '../data/dogs';

function DogStoryPage({ dogId }) {
  const [dog, setDog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0); // scroll to top when mounting
    
    async function fetchDog() {
      try {
        const { data, error } = await supabase
          .from('dogs')
          .select('*')
          .eq('id', dogId)
          .single();
          
        if (error) {
          console.error('Error fetching dog from Supabase:', error);
          // Fallback to static
          setDog(staticDogs.find(d => d.id === parseInt(dogId)) || null);
        } else if (data) {
          setDog(data);
        }
      } catch (err) {
        console.error('Error in fetch:', err);
        setDog(staticDogs.find(d => d.id === parseInt(dogId)) || null);
      } finally {
        setLoading(false);
      }
    }

    fetchDog();
  }, [dogId]);

  if (loading) {
    return (
      <>
        <Navbar />
        <div style={{ padding: '100px 24px', textAlign: 'center' }}>
          <h2>Caricamento in corso...</h2>
        </div>
      </>
    );
  }

  if (!dog) {
    return (
      <>
        <Navbar />
        <div style={{ padding: '100px 24px', textAlign: 'center' }}>
          <h2>Cane non trovato!</h2>
          <button className="btn btn-primary" onClick={() => window.location.hash = ''}>Torna alla home</button>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="container" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
        <button 
          className="btn btn-outline" 
          onClick={() => window.location.hash = ''}
          style={{ marginBottom: '40px' }}
        >
          ← Torna ai cani
        </button>

        <div style={{ display: 'flex', gap: '60px', flexWrap: 'wrap' }}>
          <div style={{ flex: '1', minWidth: '300px' }}>
            <img 
              src={dog.image} 
              alt={dog.name} 
              style={{ width: '100%', borderRadius: '40px', boxShadow: 'var(--shadow-md)', maxHeight: '600px', objectFit: 'cover' }} 
            />
          </div>

          <div style={{ flex: '1', minWidth: '300px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <h1 style={{ fontSize: '48px', marginBottom: '16px' }}>La storia di {dog.name}</h1>
            <div className="dog-tags" style={{ justifyContent: 'flex-start', marginBottom: '32px' }}>
              <span className="tag" style={{ backgroundColor: 'var(--color-bg-secondary)' }}>{dog.age}</span>
              <span className="tag" style={{ backgroundColor: 'var(--color-bg-secondary)' }}>{dog.size}</span>
            </div>

            <h3 style={{ marginBottom: '12px' }}>Il suo passato</h3>
            <p style={{ color: 'var(--color-text-light)', marginBottom: '24px', lineHeight: '1.8' }}>
              {dog.story}
            </p>

            <h3 style={{ marginBottom: '12px' }}>Condizioni di Salute</h3>
            <p style={{ color: 'var(--color-text-light)', marginBottom: '24px' }}>
              {dog.health}
            </p>

            <h3 style={{ marginBottom: '12px' }}>Compatibilità Famigliare</h3>
            <p style={{ color: 'var(--color-text-light)', marginBottom: '40px' }}>
              {dog.compatibility}
            </p>

            <div style={{ display: 'flex', gap: '16px' }}>
              <button onClick={() => { window.location.hash = `#/adozione/${dog.id}`; }} className="btn btn-primary" style={{ flex: 1 }}>Conosci {dog.name}</button>
              <button className="btn btn-secondary" onClick={() => window.location.hash = '#donazioni'} style={{ backgroundColor: '#FADDC6' }}>❤ Dona per lui</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DogStoryPage;
